/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonFormatInfo,
    JsonFormatInfoFromJSON,
    JsonFormatInfoFromJSONTyped,
    JsonFormatInfoToJSON,
} from './JsonFormatInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonFormatInfo
 */
export interface ApiResultOfJsonFormatInfo {
    /**
     * 
     * @type {JsonFormatInfo}
     * @memberof ApiResultOfJsonFormatInfo
     */
    data?: JsonFormatInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFormatInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonFormatInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFormatInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonFormatInfo
     */
    result?: ApiResultOfJsonFormatInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonFormatInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonFormatInfoFromJSON(json: any): ApiResultOfJsonFormatInfo {
    return ApiResultOfJsonFormatInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonFormatInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonFormatInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonFormatInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonFormatInfoToJSON(value?: ApiResultOfJsonFormatInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonFormatInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

